import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import i18n from '@/i18n';

type Lang = 'tr' | 'en' | 'ru';

interface LangContextType {
  lang: Lang;
  setLang: (l: Lang) => void;
}

const LangContext = createContext<LangContextType>({ lang: 'tr', setLang: () => {} });

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Lang>('tr');

  const setLang = useCallback((l: Lang) => {
    setLangState(l);
    i18n.changeLanguage(l);
  }, []);

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LangContext);
}